import { createBrowserRouter, redirect, type LoaderFunctionArgs } from "react-router";
import {
    HomePage,
    LoginPage,
    NotFoundPage,
    MerchantProductDetailPage,
    ProductDashboardsPage,
    ProductsPage,
    ProfilePage,
    RegisterPage,
    ProductsActivityPanelPage,
} from "@src/components/pages";
import { ACCESS_STORAGE_KEY } from "@src/config";
import {
    BarChartOutlined,
    HomeOutlined,
    SettingOutlined,
    ShoppingOutlined,
} from "@ant-design/icons";
import { AppLayout, type SideBarItem } from "@src/components";

const sidebarItems: SideBarItem[] = [
    { key: "home", label: "Главная", icon: <HomeOutlined />, to: "/" },
    {
        key: "products",
        label: "Товары",
        icon: <ShoppingOutlined />,
        to: "/products",
    },
    { key: "activity-panel", label: "Панель Активности", to: "/activity-panel" },
    {
        key: "analytics",
        label: "Аналитика",
        icon: <BarChartOutlined />,
        children: [{ key: "dash", label: "Дашборды", to: "/dashboards" }],
    },
    {
        key: "settings",
        label: "Настройки",
        icon: <SettingOutlined />,
        to: "/settings",
    },
];

export const router = createBrowserRouter([
    { path: "login", Component: LoginPage },
    { path: "register", Component: RegisterPage },
    {
        path: "/",
        element: <AppLayout logoSrc="/icon.png" brandName="OptimS" sidebarItems={sidebarItems} />,
        children: [
            { index: true, element: <HomePage /> },
            { path: "dashboards", element: <ProductDashboardsPage /> },
            { path: "products", element: <ProductsPage /> },
            { path: "activity-panel", element: <ProductsActivityPanelPage /> },
            { path: "products/:merchantProductId", element: <MerchantProductDetailPage /> },
            { path: "profile", element: <ProfilePage /> },
            { path: "settings", element: <HomePage /> },
        ],
        loader: requireAuth,
    },
    { path: "*", Component: NotFoundPage },
]);

async function requireAuth(args: LoaderFunctionArgs) {
    const url = new URL(args.request.url);
    const token = localStorage.getItem(ACCESS_STORAGE_KEY);

    if (!token) {
        const next = url.pathname + url.search;
        throw redirect(`/login?redirect=${encodeURIComponent(next)}`);
    }
    return null;
}
